module.exports = __webpack_public_path__ + "static/media/profile_pic.23761ce5.jpg";